import React from 'react'
import moment from 'moment'
import { Modal, Icon } from 'antd'
import { api, app } from '../../app'
import PayTemplate from '../../components/PayTemplate'

const FalseData = false

const getParams = () => {
    return {
        indexno: app.getData('indexno'),
        account: app.getData('account'),
    }
}

/**
 * 获取省份列表
 * @returns {Promise<*>}
 */
export const getProvinceList = async () => {
    const { flag, data, msg } = await app.post(api.SMProvinceList, getParams())
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return []
    }
}

/**
 * 获取队伍列表
 * @param province
 * @returns {Promise<*>}
 */
export const getTeamList = async (province) => {
    const { flag, data, msg } = await app.post(api.SMTeamList, { ...getParams(), province })
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return []
    }
}

/**
 * 获取短信服务概览
 * @param params
 * @returns {Promise<*>}
 */
export const getOverview = async (params) => {
    const { flag, data, msg } = await app.post(api.SMOverview, { ...getParams(), ...params })
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return {}
    }
}

/**
 * 获取套餐包使用详情
 * @param params
 * @returns {Promise<*>}
 */
export const getUseDetailsList = async (params) => {
    const { flag, data, msg, total } = await app.post(api.SMUseDetailsList, { ...getParams(), ...params })
    if (flag === 1) {
        return { data, total: parseInt(total || 0) }
    } else {
        app.alert(msg, 'error', '45%')
        return { data: [], total: 0 }
    }
}

/**
 * 资源包规格
 * @returns {Promise<*>}
 */
export const getResourcePack = async () => {
    const { flag, data, msg } = await app.post(api.SMResourcePack, getParams())
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return []
    }
}

/**
 * 模版列表
 * @returns {Promise<*>}
 */
export const getStencilList = async () => {
    const { flag, data, msg } = await app.post(api.SMStencilList, getParams())
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return []
    }
}

/**
 * 获取规则
 * @returns {Promise<*>}
 */
export const getRule = async () => {
    const { flag, data, msg } = await app.post(api.SMRule, getParams())
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return { content: '' }
    }
}

/**
 * 发送记录查询
 * @param params
 * @returns {Promise<*>}
 */
export const getSendRecordList = async (params) => {
    const { flag, data, msg, total, time } = await app.post(api.SMSendRecordList, { ...getParams(), ...params })
    if (flag === 1) {
        return { data, time: time ? moment(time) : moment(), total: parseInt(total || 0) }
    } else {
        app.alert(msg, 'error', '45%')
        return { data: [], total: 0, time: moment() }
    }
}

/**
 * 在线发送短信
 * @param params
 * @returns {Promise<*>}
 */
export const sendMessages = async (params) => {
    const { flag, msg } = await app.post(api.SMSendMessages, { ...getParams(), ...params })
    if (flag === 1) {
        app.alert(msg, 'success', '45%')
        return true
    } else {
        app.alert(msg, 'error', '45%')
        return false
    }
}

/**
 * 短信支付
 * @returns {Promise<*>}
 */
export const messagePay = (params) => {
    return new Promise(async (resolve) => {
        app.alert('正在加载支付...', 'loading', '45%', 0)
        const { flag, data, msg } = await app.post(api.SMSmsPay, { ...params, ...getParams() })
        app.alertDestroy()
        if (flag === 1) {
            if (flag === 1) {
                Modal.confirm({
                    title: '扫码支付',
                    centered: true,
                    icon: (<Icon type="alipay-circle" style={{ color: '#00A1E9' }}/>),
                    width: 600,
                    content: (
                        <PayTemplate qrcode={data.qrUrl} money={data.totalAmount} no={data.orderCode}/>),
                    okText: '已支付',
                    cancelText: '关闭',
                    onOk: async () => {
                        const { flag, msg } = await app.post(api.SMSConfirmPay, {
                            indexno: app.getData('indexno'),
                            account: app.getData('account'),
                            order_code: data.orderCode
                        })
                        if (flag === 1) {
                            app.alert('支付成功', 'success')
                            resolve(true)
                            return true
                        } else {
                            app.alert(msg, 'warn')
                            resolve(false)
                            throw false
                        }
                    },
                    onCancel: () => {
                        resolve(false)
                    }
                })
            } else {
                app.alert(msg, 'error')
                resolve(false)
            }
            return data
        } else {
            app.alert(msg, 'error')
            resolve(false)
        }
    })
}




/**
 * 获取生日模块身份信息
 * @returns {Promise<*>}
 */
 export const getSMSmsManage = async (params) => {
    const { flag, data, msg } = await app.post(api.SMautoTemplateList, params)
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return { content: '' }
    }
}

/**
 * 提交生日信息模板设置
 * @returns {Promise<*>}
 */
 export const postSMBDEdit = async (params) => {
    const { flag, data, msg } = await app.post(api.SMBDEdit, params)
    if (flag === 1) {
        app.alert(msg,'success', '45%')
        return msg
    } else {
        app.alert(msg, 'error', '45%')
        return { content: '' }
    }
}


/**
 * 提交入职信息模板设置
 * @returns {Promise<*>}
 */
 export const postSMjoinTeamEdit = async (params) => {
    const { flag, data, msg } = await app.post(api.SMjoinTeamEdit, params)
    if (flag === 1) {
        app.alert(msg,'success', '45%')
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return { content: '' }
    }
}


/**
 * 获取生日信息模板设置
 * @returns {Promise<*>}
 */
 export const getSMBDInfo = async (params) => {
    const { flag, data, msg } = await app.post(api.SMBDInfo, params)
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return { content: '' }
    }
}


/**
 * 获取入职信息模板设置
 * @returns {Promise<*>}
 */
 export const getSMjoinTeamInfo = async (params) => {
    const { flag, data, msg } = await app.post(api.SMjoinTeamInfo, params)
    if (flag === 1) {
        return data
    } else {
        app.alert(msg, 'error', '45%')
        return { content: '' }
    }
}




// WEBPACK FOOTER //
// ./src/routes/message/message_api.jsx